import { GADataProps } from "@components/GAData/GAData";

export const HOMEPAGE_TITLE = "The Business Times";
export const HOMEPAGE_DESCRIPTION =
  "The Business Times - Singapore's leading business and financial news source. Find latest business news, market analysis, and economic insights from Singapore and Asia-Pacific.";

export const HOMEPAGE_KEYWORDS = [
  "singapore budget 2015",
  "singapore",
  "budget 2015",
  "business & financial news",
];

export const HOMEPAGE_ALTERNATES = [
  { hrefLang: "en-sg", href: "https://www.businesstimes.com.sg/" },
  { hrefLang: "en", href: "https://www.businesstimes.com.sg/global" },
  { hrefLang: "x-default", href: "https://www.businesstimes.com.sg/" },
];

export const HOMEPAGE_GA_DATA: GADataProps = {
  title: "BT Homepage",
  level2: "home",
  cd_version: "bt2",
};
